import { useCallback } from 'react'

import { useGlobalStore } from '@core/hooks/useGlobalStore'
import type { PersistedKey } from '@core/store'
import { persistedDataSelector, sharedStateActionsSelector } from '@core/store'

type IReturn = readonly [
  string | undefined,
  (value: string | undefined) => void,
]

/**
 * Hooks to fetch and manipulate local storage value.
 * @param key - The key to fetch from local storage. Update the allowed keys in
 * `src/core/store/sharedState/state.ts`.
 */
export function useLocalStorage(key: PersistedKey): IReturn {
  const value = useGlobalStore((state) => persistedDataSelector(state, key))
  const { setPersistedData } = useGlobalStore(sharedStateActionsSelector)
  const setValue = useCallback(
    (value: string) => {
      setPersistedData(key, value)
    },
    [key, setPersistedData],
  )

  return [value, setValue] as const
}
